// extracted by mini-css-extract-plugin
export var actions = "_4n-0";
export var actionsContainer = "_4n-7";
export var border = "_4n-1";
export var childFullHeight = "_4n-f";
export var collapse = "_4n-2";
export var content = "_4n-a";
export var contentChild = "_4n-e";
export var fullscreen = "_4n-c";
export var hasLeftRadius = "_4n-k";
export var headerContainer = "_4n-3";
export var headerRow = "_4n-5";
export var hidePadding = "_4n-b";
export var navCollapsedGap = "_4n-l";
export var noScrollX = "_4n-m";
export var noScrollY = "_4n-n";
export var noTopPadding = "_4n-i";
export var optOutTopPadding = "_4n-d";
export var pageMain = "_4n-j";
export var pageOuter = "_4n-g";
export var pagePadding = "_4n-8";
export var pageScroll = "_4n-9";
export var profile = "_4n-o";
export var profileContainer = "_4n-p";
export var profileImage = "_4n-q";
export var profileMain = "_4n-r";
export var profileSubtitle = "_4n-t";
export var profileTitle = "_4n-s";
export var showLeftPadding = "_4n-h";
export var tabsPortalSlot = "_4n-6";
export var tabsWrapper = "_4n-4";
export var title = "_4n-u";